import { render, staticRenderFns } from "./TagsSelector.vue?vue&type=template&id=d9e56efa"
import script from "./TagsSelector.vue?vue&type=script&lang=js"
export * from "./TagsSelector.vue?vue&type=script&lang=js"
import style0 from "./TagsSelector.vue?vue&type=style&index=0&id=d9e56efa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports